import { useEffect, useRef, useState } from 'react'
import AnimateHeight from 'react-animate-height'
import { useLocation } from 'react-router-dom'
import { useOnClickOutside } from 'usehooks-ts'

import userIcon from '{cImg}/user.svg'
import { useWorkspaceSlug } from '~/api/swr/useWorkspaceSlug.ts'
import { LinkIcon } from '~/appComponents/LinkIcon.tsx'
import HeaderAnnouncementsTooltip from '~/features/announcements/components/HeaderAnnouncementsTooltip.tsx'

import MobileUserDropdown from './MobileUserDropdown.tsx'
import getCurrentLink from '../../../utils/getCurrentLink.ts'
import MenuUls from '../../MenuUls.tsx'
import transloaditIcon from '../images/transloadit.svg'

// import transloaditIconXmas from '../images/transloadit-xmas.svg'

function MobileHeader() {
  const { slug } = useWorkspaceSlug()
  const [isUserDropdownOpen, updateIsUserDropdownOpen] = useState(false)
  const [isNavDropdownOpen, updateIsNavDropdownOpen] = useState(false)

  const location = useLocation()

  useEffect(() => {
    updateIsUserDropdownOpen(false)
    updateIsNavDropdownOpen(false)
  }, [location.pathname])

  const navDropdownRef = useRef<HTMLDivElement>(null)
  // @ts-expect-error usehooks-ts types are not compatible with React 19 yet
  useOnClickOutside(navDropdownRef, () => {
    updateIsNavDropdownOpen(false)
  })

  const userDropdownRef = useRef(null)
  // @ts-expect-error usehooks-ts types are not compatible with React 19 yet
  useOnClickOutside(userDropdownRef, () => {
    updateIsUserDropdownOpen(false)
  })

  const currentLink = getCurrentLink(location, slug)

  return (
    <header className="header header--mobile">
      <div className="tl-container tl-container--header">
        <a className="logo" href="/">
          <img className="logo__img" src={transloaditIcon} alt="Transloadit" />
        </a>

        <div className="mobile-menu" ref={navDropdownRef}>
          <button
            type="button"
            className={`btn mobile-menu__link mobile-menu__link--${currentLink.type}`}
            onClick={() => updateIsNavDropdownOpen(!isNavDropdownOpen)}
          >
            <div className="main-menu__icon main-menu__icon--default">
              <LinkIcon type={currentLink.type} />
            </div>
            {currentLink.title}
          </button>

          <nav className="main-menu main-menu--mobile">
            <AnimateHeight height={isNavDropdownOpen ? 'auto' : 0}>
              <MenuUls />
            </AnimateHeight>
          </nav>
        </div>

        <div className="header__nav" ref={userDropdownRef}>
          <a className="header__nav-link header__nav-link--docs" href="/docs">
            Docs
          </a>

          <HeaderAnnouncementsTooltip />

          <button
            type="button"
            className="btn btn--clear header__nav-link account-menu"
            onClick={() => updateIsUserDropdownOpen(!isUserDropdownOpen)}
            aria-label="Account menu"
          >
            <img className="account-menu__img" src={userIcon} alt="" aria-hidden />
          </button>

          <MobileUserDropdown isUserDropdownOpen={isUserDropdownOpen} />
        </div>
      </div>
    </header>
  )
}

export default MobileHeader
